import './style.css'

import ReactDOM from 'react-dom/client'
import { Analytics } from '@vercel/analytics/react'
import { Leva } from 'leva'
import App from './app'
import { installGestureGuards } from './utils/preventGestures'

// Block pinch/double-tap zoom and long-press/right-click app-wide, on every
// device. Runs once before React mounts so it covers the canvas and all UI.
installGestureGuards()

// Check if dev mode is enabled via URL parameter
const isDevMode = new URLSearchParams(window.location.search).get('dev') === 'true'

const root = ReactDOM.createRoot(document.querySelector('#root'))

root.render(
  <>
    <Leva hidden={!isDevMode} />
    <App />
    <Analytics/>
  </>
)


